namespace $.$$ {

	export class $shm_hitalama_profile_badge extends $.$shm_hitalama_profile_badge {

		avatar_visible() {
			return this.avatar_uri() ? [ this.Avatar() ] : []
		}

		title() {
			return this.name()
		}

	}

}

